import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import cart from './cart/cart';
import search from './search/search';
import filters from './filters/filters';
import restaurant from './restaurant/restaurant';
import auth from './auth/auth';
import suites from './suites/suites';
import layout from './layout/layout';
import geolocation from './geolocation/geolocation';
import rallyIntelligence from './rallyIntelligence/rallyIntelligence';
import cateringBot from './cateringBot/cateringBot';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
	modules: {
		cart,
		search,
		filters,
		restaurant,
		auth,
		suites,
		layout,
		geolocation,
		rallyIntelligence,
		cateringBot
	}
};

export default new Vuex.Store<RootState>(store);